import { Injectable } from '@angular/core'

import * as _ from 'lodash'

import { AuthStore } from '@api/store/auth'
import { ProfileDto } from '@api/dto'

import { HttpService } from './http.service'

@Injectable()
export class AuthService {
  constructor(
    private httpService: HttpService,
    private authStore: AuthStore) {
  }

  async current() {
    const user = await this.httpService.get<ProfileDto>('/admin/profile')
    const authUser = _.clone(user)

    this.authStore.update({user: authUser })

    return user
  }

  async updatePassword(currentPassword: string, newPassword: string) {
    return await this.httpService.post<Boolean>('/auth/update-password', {
      currentPassword,
      newPassword
    })
  }

  async logIn(email: string, password: string, shouldRemember: boolean) {
    const { sessionToken, user } = await this.httpService.post<any>('/auth/login', {email, password})

    await this.httpService.setSessionToken(sessionToken, shouldRemember)

    return user
  }

  async logOut() {
    await this.httpService.delete('/auth/logout')

    return await this.httpService.removeSessionToken()
  }
}
